import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import AppleAppStoreDownload from './images/apple-app-store-download.png';
import GooglePlayAppStoreDownload from './images/google-play-app-store-download.png';
import MobileDeviceGraphicLg from './images/mobile-device-graphic-lg.webp';
import MobileDeviceGraphicSm from './images/mobile-device-graphic-sm.webp';
import NmAppQrCode from './images/nm-app-qr-code.png';
// styles
import {
  ColStyled,
  ColStyledAppStoreBadgeContainer,
  ColStyledGooglePlayStoreBadgeContainer,
  ColStyledPhoneContainer,
  ImgStyledAppleDownloadBadge,
  ImgStyledGooglePlayBadge,
  PictureStyledPhone,
  PictureStyledQrCode,
  RowStyled,
  SectionContainerStyled,
  TypographyStyled,
} from './styles';

export default () => {
  const theme = useContext(ThemeContext);
  const isMediumUp = theme.mediumUp();

  const AppleStoreLink = 'https://northwesternmutual.page.link/?link=https%3A%2F%2Fwww.northwesternmutual.com%2Fapp%2Fcampaign%3Futm_source%3Dnmcom_applanding%26utm_medium%3Dweb%26utm_campaign%3Dmobileappbadges_Q4_2022%26utm_content%3Dclient_mobileappdownload%26utm_term%3Dios&apn=com.nm.nm&amv=0&ibi=com.nm.nm.ios&isi=1132579006&st=To%20continue%20%26%20download%20the%20app%2C%20click%20%22OPEN%22%20below.&sd=Northwestern%20Mutual%20Mobile%20App&ofl=https%3A%2F%2Fapps.apple.com%2Fus%2Fapp%2Fnorthwestern-mutual%2Fid1132579006';

  const GooglePlayStoreLink = 'https://northwesternmutual.page.link/?link=https%3A%2F%2Fwww.northwesternmutual.com%2Fapp%2Fcampaign%3Futm_source%3Dnmcom_applanding%26utm_medium%3Dweb%26utm_campaign%3Dmobileappbadges_Q4_2022%26utm_content%3Dclient_mobileappdownload%26utm_term%3Dandroid&apn=com.nm.nm&amv=0&ibi=com.nm.nm.ios&isi=1132579006&st=To%20continue%20%26%20download%20the%20app%2C%20click%20%22OPEN%22%20below.&sd=Northwestern%20Mutual%20Mobile%20App&ofl=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.nm.nm';

  const getIntroText = () => {
    return (
      <TypographyStyled
        align='left'
        disableBottomPadding>
        Get fast, easy, and secure access to your accounts and more&#8212;anytime, anywhere.
      </TypographyStyled>
    );
  };

  return (
    <SectionContainerStyled
      id='app-download-page'
      backgroundVariant='lightA'
      themeType='lightTheme'
      moduleName='intro-module'
      moduleVariation='A'
      disableBottomPadding>
      <Row align='center'>
        <Col align='center'>
          <Typography
            component='h1'
            nextElement={isMediumUp ? 'graphic' : 'typography'}>
            Download our <WidowBlock>mobile app</WidowBlock>
          </Typography>
          {/* for mobile */}
          {!isMediumUp && getIntroText()}
        </Col>
      </Row>
      <Row align='center'>
        <Col large={10}>
          <RowStyled align='center'>
            <ColStyledPhoneContainer
              small={7}
              medium={6}
              xlarge={4}
              className='nmx-no-print'>
              <PictureStyledPhone
                lazyLoad
                variant='rectangular'
                src={isMediumUp ? MobileDeviceGraphicLg : MobileDeviceGraphicSm}
                altText='A mobile device featuring the Northwestern Mutual app'
                fullWidth={false} />
            </ColStyledPhoneContainer>
            <ColStyled
              small={5}
              medium={6}
              nested>
              {isMediumUp && (
                <>
                  {getIntroText()}
                  <PictureStyledQrCode
                    lazyLoad={false}
                    variant='rectangular'
                    src={NmAppQrCode}
                    altText='Northwestern Mutual app QR Code'
                    fullWidth />
                  <Typography
                    component='small'
                    nextElement='graphic'>
                    To download or open the app, use the camera on your mobile device to scan the QR code.
                  </Typography>
                </>
              )}
              <Row align='center'>
                <ColStyledAppStoreBadgeContainer
                  small={8}
                  medium={6}
                  nested>
                  <Link
                    linkUrl={AppleStoreLink}
                    ariaLabel='Northwestern Mutual Apple App store download link'
                    isOutgoingLink>
                    <ImgStyledAppleDownloadBadge
                      src={AppleAppStoreDownload}
                      alt='Northwestern Mutual Apple App store download' />
                  </Link>
                </ColStyledAppStoreBadgeContainer>
                <ColStyledGooglePlayStoreBadgeContainer
                  small={8}
                  medium={6}
                  nested>
                  <Link
                    linkUrl={GooglePlayStoreLink}
                    ariaLabel='Northwestern Mutual Google Play App store download link'
                    isOutgoingLink>
                    <ImgStyledGooglePlayBadge
                      src={GooglePlayAppStoreDownload}
                      alt='Northwestern Mutual Google Play App store download'
                    />
                  </Link>
                </ColStyledGooglePlayStoreBadgeContainer>
              </Row>
            </ColStyled>
          </RowStyled>
        </Col>
      </Row>
    </SectionContainerStyled>
  );
};
